/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MCQResultSummary } from './mCQResultSummary';

export type SubmissionMcqResult = MCQResultSummary | null;
